/**
 * Iter 61 — Shared scroll helper used by every "seek to comment" path
 * (ShareView + AssetDetailModal). Ports the bounding-rect math from the
 * drawing overlay: read `getBoundingClientRect()` and only scroll when the
 * target's on-screen intersection is under a threshold. Uses
 * `scrollIntoView({ block:'nearest' })` so the nearest scrollable ancestor
 * moves the minimum amount — the parent header never gets pinned off-screen.
 *
 * @param el        DOM element to make sure is visible
 * @param minPx     minimum visible pixels required before we consider it in view
 */
export function maybeNudgeIntoView(el, minPx = 80) {
  if (!el || typeof el.getBoundingClientRect !== "function") return;
  const rect = el.getBoundingClientRect();
  const vh = window.innerHeight || document.documentElement.clientHeight;
  const visibleTop = Math.max(0, rect.top);
  const visibleBottom = Math.min(vh, rect.bottom);
  const visibleHeight = Math.max(0, visibleBottom - visibleTop);
  if (visibleHeight >= minPx) return;
  try {
    el.scrollIntoView({ behavior: "smooth", block: "nearest" });
  } catch (e) {
    /* older browsers: silent no-op */
  }
}
